/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { requisitionsProductListStyles } from "@monsma/Overrides/Widgets/Requisitions/RequisitionsProductList";
import { css } from "styled-components";

requisitionsProductListStyles.noResultsContainer = {
    css: css`
        text-align: center;
        padding: 20px 0;
    `,
};

requisitionsProductListStyles.countText = {
    weight: 800,

    css: css`
        vertical-align: top;
        margin-right: 30px;
    `,
};

requisitionsProductListStyles.selectAllCheckbox = {};
